import React, { Component } from "react";
import { Popover, Form, Button, Icon, Table, Modal, Input, Select, message, Tree } from "antd";
import {
    addOrEditOperate,
    selectOperate,
    GetAllCheckHospitalInfo,
    GetCheckHospitalInfo,
    GetCheckedHospitalInfo,
    deleteOperate,
} from "@/request/api";
import "./settingUser.scss";
import {requestErrorLog } from '@/common/util'

const { TextArea } = Input;
const { Option } = Select;
const { confirm } = Modal;

class Operate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableList: [],
            PageNo: 1,
            PageSize: 10,
            RowCount: 12,
            operateColumns: [
                {
                    title: "人员编码",
                    dataIndex: "OPERATION_UID",
                    key: "OPERATION_UID",
                    ellipsis: true,
                    width: 100,
                    render: (text, record, index) => {
                        //生成序号
                        return <span>{(this.state.PageNo - 1) * 10 + (index + 1)}</span>;
                    },
                },
                {
                    title: "人员姓名",
                    dataIndex: "OPERATION_NAME",
                    key: "OPERATION_NAME",
                    ellipsis: true,
                    align: "center",
                    width: 200,
                },
                {
                    title: "联系电话",
                    dataIndex: "OPERATION_PHONE",
                    key: "OPERATION_PHONE",
                    ellipsis: true,
                    align: "center",
                    width: 200,
                },
                {
                    title: "公司名称",
                    dataIndex: "COMPANY_NAME",
                    key: "COMPANY_NAME",
                    ellipsis: true,
                    align: "center",
                    width: 200,
                },
                {
                    title: "岗位权限",
                    dataIndex: "OPERATION_JOB_PER",
                    key: "OPERATION_JOB_PER",
                    ellipsis: true,
                    align: "center",
                    width: 200,
                },
                {
                    title: "备注",
                    dataIndex: "REMARKS",
                    key: "REMARKS",
                    ellipsis: true,
                    align: "center",
                    width: 300,
                    render: (text) => {
                        return (
                            <Popover overlayStyle={{ width: "300px" }} content={<span style={{ color: "#333" }}>{text}</span>}>
                                <span>{text}</span>
                            </Popover>
                        );
                    }
                }
            ],
            treeData: [],//重组后的树
            checkedKeys: [],//选中的数据
            treeDataT: []//处理后的第三层数据
        };
    }

    componentDidMount() {
        this.getOperateList();
    }
    //获取树形控件数据
    getTreeData = async (value) => {
        let res = {}
        if (value === '管理员') {
            res = await GetAllCheckHospitalInfo();
        } else {
            if (this.state.modalTitle === 'ADD') {
                res = await GetCheckHospitalInfo();
            } else {
                res = await GetCheckedHospitalInfo(this.state.rowData.OPERATION_UID);
            }
        }
        let treeDataAll = []
        if (res && res.Status === 1) {
            treeDataAll = res.Result
        }else{
			requestErrorLog('', '权限管理-运营管理-获取关联机构报错', 0, true)
		}
        //处理第三层数据key可能重复的问题
        let newTreeArr = []//重组后的树
        let treeDataT = []//处理后的第三层数据
        for (let i = 0; i < treeDataAll.length; i++) {
            let parentData = treeDataAll[i].children, newParentArr = []
            for (let j = 0; j < parentData.length; j++) {
                let sonData = parentData[j].children, newSonArr = []
                for (let k = 0; k < sonData.length; k++) {
                    let sonSingle = {
                        key: treeDataAll[i].key + parentData[j].key + '&' + sonData[k].key,
                        title: sonData[k].title
                    }
                    newSonArr.push(sonSingle)
                    treeDataT.push(sonSingle.key)
                }
                let parentSingle = {
                    key: parentData[j].key,
                    title: parentData[j].title,
                    children: newSonArr
                }
                newParentArr.push(parentSingle)
            }
            let grandfatherSingle = {
                key: treeDataAll[i].key,
                title: treeDataAll[i].title,
                children: newParentArr
            }
            newTreeArr.push(grandfatherSingle)
        }
        this.setState({
            treeData: newTreeArr,
            treeDataT,
            checkedKeys: [],//切换权限，清空选项
        })
    }


	handleOperateList = () => {
		this.setState({ PageNo: 1 }, this.getOperateList);
	};
    getOperateList = async () => {
        let params = {
            Type: "Select",
            searchValue: this.props.form.getFieldValue("operateName") || "",
            pageNo: this.state.PageNo,
            pageSize: this.state.PageSize,
        };
        let res = await selectOperate(params);
        if (res && res.Status === 1) {
            const dataList = res.Result.dataList;
            let RowCount = res.Result.rowCount;
            this.setState({
                tableList: dataList,
                RowCount,
            });
        }else{
			requestErrorLog('', '权限管理-运营管理-获取运营人员列表报错', 0, true)
		}
    };
    handleOperateSubmit = () => {
        const { modalTitle } = this.state;
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                if (modalTitle === "ADD") {
                    this.addOrEditOperate(values);
                } else {
                    confirm({
                        title: '编辑操作',
                        content: '确认修改该运营人员吗？',
                        onOk: () => {
                            this.addOrEditOperate(values);
                        },
                    });
                }
            }
        });
    };

    handleOperateEdit = () => {
        // 修改
        const { rowData } = this.state;
        if (rowData && rowData.OPERATION_UID) {
            this.setState({
                isModalVisible: true,
                modalTitle: "EDIT"
            }, async () => {
                await this.getTreeData(rowData.OPERATION_JOB_PER)
                //编辑的时候回显选中项(编辑时，如果有删除过的分组医院关系，去除对应项)
                let checkedKeys = this.state.modalTitle === 'EDIT' ? this.state.rowData.CHECK_NODES.split(',') : []
                checkedKeys = checkedKeys.filter(item => this.state.treeDataT.includes(item))
                this.setState({
                    checkedKeys,
                })

            });
        } else {
            message.warning("请先选择要操作的数据");
        }
    };

    handleOperateDelete = async () => {
        // 删除
        const { rowData } = this.state;
        if (rowData && rowData.OPERATION_UID) {
            confirm({
                title: '删除操作',
                content: '确认删除该运营人员吗？',
                onOk: async () => {
                    let res = await deleteOperate(rowData.OPERATION_UID)
                    if (res && res.Status === 1) {
                        message.success('删除成功')
                        this.handleCancel();
                        this.getOperateList();

                    } else {
                        requestErrorLog('', '权限管理-运营管理-删除运营人员报错', 0, true)
                        message.error('删除失败')
                    }
                },
            });
        } else {
            message.warning("请先选择要操作的数据");
        }
    }
    addOrEditOperate = async (values) => {
        let RequestModel = {
            // "OPERATION_NAME": "测试Test",//人员姓名
            // "OPERATION_PHONE": "15010060423",//联系电话
            // "OPERATION_PASSWORD": "123456",//登录密码
            // "OPERATION_JOB_TITLE": "销售",//岗位职称
            // "OPERATION_JOB_PER": "业务员",//岗位权限
            // "COMPANY_NAME": "xxxx有限公司",//公司名称    
            // "REMARKS": "备注",//
            // "CRETAE_DATE": "2024-01-18 13:11",//创建时间
            // "FIRST_GROUP_CODE": "F111",//一级节点
            // "SECOND_GROUP_CODE": "S111,S222",//二级节点 
            // "CHECK_HOSPITAL_CODE": "101,102",//选中的医院  
            // "CHECK_NODES": ""//选中的树节点 
            ...values
        }
        //一级节点、二级节点、医院、树节点处理
        let allData = this.state.checkedKeys.filter(item => item.indexOf('&') > -1)
        let allFIRST_GROUP_CODE = [], allSECOND_GROUP_CODE = [], allCHECK_HOSPITAL_CODE = [];
        for (let i = 0; i < allData.length; i++) {
            let FIRST_GROUP_CODE = allData[i].split('S')[0]
            let SECOND_GROUP_CODE = 'S' + allData[i].split('&')[0].split('S')[1]
            let CHECK_HOSPITAL_CODE = allData[i].split('&')[1]
            allFIRST_GROUP_CODE.push(FIRST_GROUP_CODE)
            allSECOND_GROUP_CODE.push(SECOND_GROUP_CODE)
            allCHECK_HOSPITAL_CODE.push(CHECK_HOSPITAL_CODE)
        }
        RequestModel.FIRST_GROUP_CODE = allFIRST_GROUP_CODE.toString();
        RequestModel.SECOND_GROUP_CODE = allSECOND_GROUP_CODE.toString();
        RequestModel.CHECK_HOSPITAL_CODE = allCHECK_HOSPITAL_CODE.toString();
        RequestModel.CHECK_NODES = allData.toString();
        let res = {}
        if (this.state.modalTitle === 'ADD') {
            res = await addOrEditOperate('Add', RequestModel)
        } else {
            if (values.OPERATION_PASSWORD === '********') {
                RequestModel.OPERATION_PASSWORD = this.state.rowData.OPERATION_PASSWORD
            }
            RequestModel.OPERATION_UID = this.state.rowData.OPERATION_UID
            res = await addOrEditOperate('Edit', RequestModel)
        }
        if (res && res.Status === 1) {
            if (res.Result === '2') {
                if (this.state.modalTitle === 'ADD') {
                    message.warn("手机号重复，添加失败！");
                } else {
                    message.warn("手机号重复，编辑失败！");
                }
            } else {
                this.handleCancel();
                if (this.state.modalTitle === 'ADD') {
                    message.success("添加成功！");
                    this.changePageFn(1);
                } else {
                    message.success("编辑成功！");
                    this.changePageFn(this.state.PageNo);
                }
            }
        } else {
            if (this.state.modalTitle === 'ADD') {
                requestErrorLog('', '权限管理-运营管理-添加运营人员报错', 0, true)
                message.error('添加失败！')
            } else {
                requestErrorLog('', '权限管理-运营管理-编辑运营人员报错', 0, true)
                message.error('编辑失败！')
            }
        }
    };

    onClickRow = (record) => {
        return {
            onClick: () => {
                this.setState({
                    rowData: record
                });
            }
        };
    };

    setRowClassName = (record) => {
        return record === this.state.rowData ? "clickRowStyl" : "";
    };

    handleCancel = () => {
        this.setState({
            isModalVisible: false,
            checkedKeys: [],
            rowData: [],
        });
        this.props.form.resetFields();
    };
    changePageFn = (PageNo) => {
        this.setState({ PageNo }, this.getOperateList);
    };
    //选择树状控件
    onCheckTreeData = (checkedKeys, e) => {
        if (e.checked) {//选中
            //取所有选中的医院
            let checkHosptialData = [...new Set(checkedKeys.filter(item => item.indexOf('&') > -1).map(item => { return item.split('&')[1] }))]
            let treeDataT = this.state.treeDataT
            let otherSameHosptialData = []
            for (let i = 0; i < treeDataT.length; i++) {
                for (let j = 0; j < checkHosptialData.length; j++) {
                    if (treeDataT[i].split("&")[1] === checkHosptialData[j]) {
                        otherSameHosptialData.push(treeDataT[i])
                    }
                }
            }
            let arr = [...new Set([...otherSameHosptialData, ...checkedKeys])]//去重

            this.props.form.setFieldsValue({
                "Tree": arr.length > 0 ? arr : undefined,
            });
            this.setState({
                checkedKeys: arr,
            })
        } else {//取消选中
            //获取，取消选中的医院
            let oldCheckedKeys = this.state.checkedKeys
            let newCheckedKeys = checkedKeys
            if (checkedKeys.length > 0) {
                let differentCheckedKeys = oldCheckedKeys.filter(item => !newCheckedKeys.includes(item))
                differentCheckedKeys = [...new Set(differentCheckedKeys.filter(item => item.indexOf("&") > -1).map((item) => {
                    return item.split('&')[1]
                }))]
                newCheckedKeys = newCheckedKeys.filter(item => item.indexOf('&') > -1 && !differentCheckedKeys.includes(item.split('&')[1]))
            }
            this.props.form.setFieldsValue({
                "Tree": newCheckedKeys.length > 0 ? newCheckedKeys : undefined,
            });
            this.setState({
                checkedKeys: newCheckedKeys
            })
        }
    }

    handleOperateAdd = () => {
        this.setState({
            isModalVisible: true,
            modalTitle: "ADD",
            rowData: {},
            treeData: [],
            treeDataT: [],
        });
    };
	changeFocus = (e) => {
		if (e.keyCode === 13) {
			this.handleOperateList();
		}
	};
    render() {
        const { getFieldDecorator } = this.props.form;
        const { isModalVisible, modalTitle, operateColumns, tableList, rowData, } = this.state;
        return (
            <div className="grouping">
                <div className="btnStyle" style={{ marginBottom: "10px" }}>
                    <Button onClick={this.handleOperateAdd}>
                        <Icon type="plus-circle" />
                        添加
                    </Button>
                    <Button onClick={this.handleOperateEdit}>
                        <Icon type="minus-circle" />
                        修改
                    </Button>
                    <Button onClick={this.handleOperateDelete}>
                        <Icon type="close-circle" />
                        删除
                    </Button>
                </div>
                <Form layout="inline" className="searchBox">
                    <Form.Item label="信息查询">
                        {getFieldDecorator("operateName")(<Input allowClear  onKeyUp={this.changeFocus} />)}
                    </Form.Item>
                    <Button onClick={this.handleOperateList}>查询</Button>
                </Form>
                <Table
                    columns={operateColumns}
                    dataSource={tableList}
                    rowKey={(record) => record.OPERATION_UID}
                    pagination={{
                        total: this.state.RowCount,
                        current: this.state.PageNo,
                        onChange: this.changePageFn
                    }}
                    onRow={this.onClickRow}
                    rowClassName={this.setRowClassName}
                />
                {isModalVisible ? (
                    <Modal
                        title={
                            <div className="patient_title">
                                <img alt="" src={require("@/assets/image/ecg.png").default} className="addIcon" />
                                <span>{modalTitle === "ADD" ? "添加运营人员" : "编辑运营人员"}</span>
                            </div>
                        }
                        visible={isModalVisible}
                        maskClosable={false}
                        onOk={this.handleOperateSubmit}
                        onCancel={this.handleCancel}
                        width={1000}
                        height={500}>
                        <Form layout="inline" style={{ display: 'flex' }}>
                            <div style={{ width: '50%' }}>
                                <Form.Item label="人员姓名" className="settingHospitalRequire">
                                    {getFieldDecorator("OPERATION_NAME", { initialValue: rowData.OPERATION_NAME, rules: [{ required: true, message: '请输入人员姓名' }] })
                                        (<Input placeholder="请输入人员姓名" allowClear={true} maxLength={32} style={{ width: 200 }} />)}
                                </Form.Item>
                                <Form.Item label="联系电话" className="settingHospitalRequire">
                                    {getFieldDecorator("OPERATION_PHONE", {
                                        initialValue: rowData.OPERATION_PHONE, rules: [
                                            { required: true, message: "请输入手机号！" },
                                            { message: "请输入正确的手机号！", pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/ }
                                        ]
                                    })(<Input placeholder="请输入联系电话" allowClear={true} maxLength={32} style={{ width: 200 }} />)}
                                </Form.Item>
                                <Form.Item label="登录密码" className="settingHospitalRequire">
                                    {getFieldDecorator("OPERATION_PASSWORD", { initialValue: modalTitle === "EDIT" ? '********' : '', rules: [{ required: true, message: '请输入登录密码' }] })(<Input placeholder="请输入登录密码" type="password" allowClear={true} />)}

                                </Form.Item>
                                <Form.Item label="岗位职称" className="settingHospitalRequire">
                                    {getFieldDecorator("OPERATION_JOB_TITLE", { initialValue: rowData.OPERATION_JOB_TITLE, rules: [{ required: true, message: '请输入岗位职称' }] })(<Input placeholder="请输入岗位职称" allowClear={true} />)}
                                </Form.Item>
                                <Form.Item label="岗位权限" className="settingHospitalRequire">
                                    {getFieldDecorator("OPERATION_JOB_PER", { initialValue: rowData.OPERATION_JOB_PER, rules: [{ required: true, message: '请选择岗位权限' }] })(
                                        <Select style={{ width: 200 }} onChange={this.getTreeData}>
                                            <Option key="1" value="业务员">业务员</Option>
                                            <Option key="2" value="管理员">管理员</Option>
                                        </Select>
                                    )}
                                </Form.Item>
                                <Form.Item label="公司名称" className="settingHospitalRequire">
                                    {getFieldDecorator("COMPANY_NAME", { initialValue: rowData.COMPANY_NAME, rules: [{ required: true, message: '请输入公司名称' }] })(<Input placeholder="请输入公司名称" allowClear={true} />)}
                                </Form.Item>
                                <Form.Item label="备 注" className="settingHospitalAddr">
                                    {getFieldDecorator("REMARKS", { initialValue: rowData.REMARKS })(<TextArea rows={4} style={{ width: "400px", marginTop: '5px' }} />)}
                                </Form.Item>
                            </div>
                            <div style={{ width: '50%' }}>
                                <Form.Item label="关联机构" className="settingHospitalAddr treeOverFlowStyle">
                                    {getFieldDecorator("Tree", { initialValue: rowData.allData, rules: [{ required: this.state.checkedKeys.length > 0 ? false : true, message: '请选择关联机构' }] })(
                                        <Tree
                                            checkable//复选框
                                            // checkStrictly={true}//复选款，父子之间不关联
                                            treeData={this.state.treeData}//树形控件所有数据
                                            onCheck={this.onCheckTreeData}
                                            checkedKeys={this.state.checkedKeys}
                                        />
                                    )}
                                </Form.Item>
                            </div>
                        </Form>
                    </Modal>
                ) : null}
            </div>
        );
    }
}

export default Form.create({})(Operate);
